import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back.");
      const dest = location.state?.from || "/";
      navigate(dest);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] max-w-md mx-auto px-6 py-20">
      <div className="label-eyebrow text-sage mb-3">Folio account</div>
      <h1 className="font-serif text-5xl tracking-tight mb-2">Sign in.</h1>
      <p className="text-muted_ink mb-10">Welcome back to your shelf.</p>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="label-eyebrow block mb-2">Email</label>
          <Input
            data-testid="login-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="h-12 bg-transparent border border-edge rounded-none focus-visible:ring-terracotta focus-visible:ring-1"
          />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Password</label>
          <Input
            data-testid="login-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-12 bg-transparent border border-edge rounded-none focus-visible:ring-terracotta focus-visible:ring-1"
          />
        </div>
        {error && (
          <div data-testid="login-error" className="text-sm text-terracotta border-l-2 border-terracotta pl-3">{error}</div>
        )}
        <button
          data-testid="login-submit-btn"
          type="submit"
          disabled={loading}
          className="btn-primary w-full disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>

      <div className="text-center mt-8 text-sm text-muted_ink">
        <Link to="/forgot-password" data-testid="link-forgot" className="hover:text-terracotta underline underline-offset-4 decoration-terracotta">
          Forgot password?
        </Link>
      </div>

      <div className="text-center mt-4 text-sm text-muted_ink">
        New to Folio?{" "}
        <Link to="/register" data-testid="link-to-register" className="text-ink underline underline-offset-4 decoration-terracotta">
          Create an account
        </Link>
      </div>
    </div>
  );
}
